import * as TerrassorConst from '../../terrassor_const.js'
import { set_Terrassor_INTERFACE, get_Terrassor_INTERFACE } from "../../interface.js";

import dateFns from 'date-fns'


/* @ngInject */
export class ApiSimu {
  /* @ngInject */
  constructor(TerrassorDB, $q) { // Injection des dépendances TerrassorDB et $q
    // on les enregistre sur 'this' afin de les reutiliser plus tard.
    this.TerrassorDB = TerrassorDB
    this.$q = $q

  this.analyseFieldsToSerialize =
      ['erreursCoherenceTab', 'erreursDureeTab', 'erreursInstallationTab', 'erreursInutileTab', 'erreursRemblaiTab', 'erreursUsageTab', 'tabBonusQualiteMouvements', 'tabBonusInstallationQ','tabBonusInstallationS','tabBonusInstallationE'/*, 'erreursEpureTab'*/]

  }



  /*@Todo, filtrer par eleve
  */
  getSimuEtude() {
     return this.TerrassorDB.readAllFromTable('simu_etudes')
  }
  /*@Todo, filtrer par eleve
  */
  getSimuAnalyse() {
     return this.TerrassorDB.readAllFromTable('simu_analyses')
  }
  getSimuAnalyseNow() {
     return this.TerrassorDB.getFirstRowInTableImmediate('simu_analyses')
  }
  getSimuExoChantier() {
     return this.TerrassorDB.readAllFromTable('simuexo_chantiers')
  }
  getSimuExoChantierNow() {
     return this.TerrassorDB.getFirstRowInTableImmediate('simuexo_chantiers')
  }
  saveSimuExoChantier(rowData) {
    return this.TerrassorDB.saveRowInTable(rowData, 'simuexo_chantiers')
  }
  saveExoChantier(rowData) {
    return this.TerrassorDB.saveRowInTable(rowData, 'exo_chantiers')
  }
  getSimuExoCubatures() {
     return this.TerrassorDB.readAllFromTable('simuexo_cubatures')
  }
  getSimuExoCubaturesCouches() {
     return this.TerrassorDB.readAllFromTable('simuexo_cubatures_couches')
  }
  /*getSimuExoCubatures_simuExoCubatures() {
     return this.TerrassorDB.readAllFromTable('simuexo_cubatures_simuexo_cubatures')
  }*/
  saveSimuExoCubatures(rowData) {
    return this.TerrassorDB.saveRowInTable(rowData, 'simuexo_cubatures')
  }
  saveExoCubatures(rowData) {
    return this.TerrassorDB.saveRowInTable(rowData, 'exo_cubatures')
  }
  saveSimuExoMouvements(rowData) {
    return this.TerrassorDB.saveRowInTable(rowData, 'simuexo_mouvements')
  }
  saveExoMouvements(rowData) {
    return this.TerrassorDB.saveRowInTable(rowData, 'exo_mouvements')
  }
  saveSimuExoMouvementsCubatures(rowData) {
    return this.TerrassorDB.saveRowInTable(rowData, 'simuexo_mouvements_simuexo_cubatures')
  }
  saveExoMouvementsCubatures(rowData) {
    return this.TerrassorDB.saveRowInTable(rowData, 'exo_cubatures_exo_mouvements')
  }
  getSimuExoMouvements() {
     return this.TerrassorDB.readAllFromTable('simuexo_mouvements')
  }
  getSimuExoMouvementsCubatures() {
     return this.TerrassorDB.readAllFromTable('simuexo_mouvements_simuexo_cubatures')
  }


  saveSimuExoCubaturesCouches(rowData) {
    return this.TerrassorDB.saveRowInTable(rowData, 'simuexo_cubatures_couches')
  }
  deleteSimuExoCubatures(cubature) {
      return this.TerrassorDB.deleteRowInTable(cubature.id, 'simuexo_cubatures')
  }
  deleteSimuExoCubaturesCouches(cubatureCouche) {
      return this.TerrassorDB.deleteRowInTable(cubatureCouche.id, 'simuexo_cubatures_couches')
  }

  deleteSimuExoMouvements(mouvement) {
      return this.TerrassorDB.deleteRowInTable(mouvement.id, 'simuexo_mouvements')
  }
  deleteSimuExoMouvementsCubatures(mouvementCubature) {
      return this.TerrassorDB.deleteRowInTable(mouvementCubature.id, 'simuexo_mouvements_simuexo_cubatures')
  }


  getConstHumidites() {
     return this.TerrassorDB.readAllFromTable('const_humidites')
  }
  getConstCubaturesTypes() {
     return this.TerrassorDB.readAllFromTable('const_cubaturestypes')
  }
  getConstSols() {
     return this.TerrassorDB.readAllFromTable('const_sols')
  }
/*
* Lecture des echelons d'un mvt (i.e. exo_mouvements)
*/
  getEchelons(simu_mouvements_id) {
    return this.TerrassorDB.getDbConnection()
    .then(db => {
      // On récupère la référence vers la table
      let { simu_echelons } = this.TerrassorDB.tables

      let query;
        query = db
          .select()
          .from(simu_echelons)
          .where(simu_echelons.simu_mouvements_id.eq(simu_mouvements_id))
                  /*lf.op.and
                  (simu_echelons.simu_etudes_id.eq(TerrassorConst.CURRENT_ETUDE_ID),
                  simu_echelons.exo_mouvements_id.eq(exo_mouvements_id))) */
          .exec()
      // On retourne la promesse de la requete
      return this.$q.resolve(query)
    })
  }

 /*
 * Renvoie le nombre d'échelons d'un mouvement (simu-)
 */
 countEchelons(simu_mouvement) {

    //console.log('ApiSimu::countEchelons for mvt', simu_mouvement)
    let { simu_echelons } = this.TerrassorDB.tables

    return this.TerrassorDB.getDbConnection()
    .then(db => {
    let query = db
        .select(lf.fn.count(simu_echelons.id))
        .from(simu_echelons)
        .where(simu_echelons.simu_mouvements_id.eq(simu_mouvement.id))
        .exec()
        return query
    })
}

/*
*Nouvelle entrée dans la table simu_echelons
* @todo utiliser les outils de TerrassorDB (addinTable)
*/
  createEchelon(simu_mouvement) {
    var nb_echelons = 0

    return this.countEchelons(simu_mouvement)
    .then(resultsArray => {
    var N = resultsArray[0]['COUNT(id)']
    nb_echelons = N
    //console.log('ApiSimu::countEchelons ', nb_echelons)
    return N

    // On execute la requete d'insertion
    // https://github.com/google/lovefield/blob/master/docs/spec/04_query.md
    })
    .then( _ => {
    return this.TerrassorDB.getDbConnection()
    })
    .then(db => {
      let { simu_echelons } = this.TerrassorDB.tables
      var row = simu_echelons.createRow({
          'ordre' : nb_echelons+1,
          'simu_mouvements_id': simu_mouvement.id        })

    let query = db
        .insertOrReplace()
        .into(simu_echelons)
        .values([row]) // Toujours dans un tableau même s'il n'y en a qu'une.
        .exec()

    return this.$q.resolve(query)
  })
  .then(resultsArray => {
  var insertedRow = resultsArray.pop()

        var retour = get_Terrassor_INTERFACE().action({"table":"simu_echelons", "push":insertedRow})
        console.log('ApiSimu::createEchelon, INTERFACE.action push', retour)

  //console.log('ApiSimu::createEchelon', insertedRow)
  return this.$q.resolve(insertedRow)
  })
.catch(e => {console.log('error ApiSimu::createEchelon', e);})
  }


  /*
  * 
  */
  deleteEchelon(echelon) {
    get_Terrassor_INTERFACE().action({"table":"simu_echelons", "delete":{"id": echelon.id}});
      return this.TerrassorDB.deleteRowInTable(echelon.id, 'simu_echelons')
  }

/*
* renvoit les infos nécessaires à l'établissement du formulaire d'ajout
*/
  getEnginsPhasesOptions(echelon) {
    return this.TerrassorDB.getDbConnection()
    .then(db => {
            // On récupère la référence vers la table
    let { simu_echelons_simu_engins } = this.TerrassorDB.tables
    let { const_phases } = this.TerrassorDB.tables
    let { const_engins } = this.TerrassorDB.tables
    let { const_famillesengins } = this.TerrassorDB.tables
    let { simu_engins } = this.TerrassorDB.tables
    let query;

    query = db
    .select(const_phases.code.as('const_phases_code')
            ,const_phases.nom.as('const_phases_nom')
            ,const_phases.ordre.as('const_phases_ordre')
            ,const_engins.nom.as('const_engins_nom')
            ,const_engins.code.as('const_engins_code')
            ,const_engins.id.as('const_engins_id')
            ,const_famillesengins.nom.as('const_famillesengins_nom')
            ,const_famillesengins.code.as('const_famillesengins_code')
            ,simu_echelons_simu_engins.const_options_id.as('const_options_id')
            ,simu_echelons_simu_engins.const_godets_id.as('const_godets_id')
            ,simu_echelons_simu_engins.id.as('simu_echelons_simu_engins_id')
            ,simu_engins.id.as('simu_engins_id')
            ,simu_engins.reference.as('simu_engins_reference')
            //,const_options.nom.as('const_options_nom')
      )
    .from(const_phases)
    .innerJoin(simu_echelons_simu_engins,
        simu_echelons_simu_engins.const_phases_id.eq(const_phases.id))
    .innerJoin(simu_engins,
        simu_echelons_simu_engins.simu_engins_id.eq(simu_engins.id))
    .innerJoin(const_engins,
         simu_engins.const_engins_id.eq(const_engins.id))
    .innerJoin(const_famillesengins,
          const_engins.const_famillesengins_id.eq(const_famillesengins.id))
    .where(simu_echelons_simu_engins.simu_echelons_id.eq(echelon.id))
    .orderBy(const_phases.ordre)
    .exec()

    // On retourne la promesse de la requete
    return this.$q.resolve(query)
    })

  }

/*
* Engins similaires réutilisables. Le groupBy simu_engin_id ne fonctione pas. Il faudra le faire dans le controlleur add-engins
* Ici, on retourne toutes les périodes d'usages d'engins similaires
*/
  getReusableEngins(constEngin, currentMouvement) {

    console.log('ApiSimu::getReusableEngins', constEngin, currentMouvement)
    var currentSimuMouvement = currentMouvement.simuMouvement

     return this.TerrassorDB.getDbConnection()
    .then(db => {
    let { simu_echelons_simu_engins } = this.TerrassorDB.tables
    let { simu_engins } = this.TerrassorDB.tables
    let { simu_mouvements } = this.TerrassorDB.tables
    let { exo_mouvements } = this.TerrassorDB.tables
    let { simu_echelons } = this.TerrassorDB.tables
    let { const_engins } = this.TerrassorDB.tables
    let query;

    query = db
    
    .select()
    .from(simu_engins)
    .innerJoin(simu_echelons_simu_engins,
       simu_echelons_simu_engins.simu_engins_id.eq(simu_engins.id)) // <=> on
    .innerJoin(simu_echelons,
       simu_echelons.id.eq(simu_echelons_simu_engins.simu_echelons_id))
    .innerJoin(simu_mouvements,
       simu_mouvements.id.eq(simu_echelons.simu_mouvements_id))
    .innerJoin(exo_mouvements,
       exo_mouvements.id.eq(simu_mouvements.exo_mouvements_id))
    .innerJoin(const_engins,
       const_engins.id.eq(simu_engins.const_engins_id))

    // 14.03.17 on renvoie toutes les périodes concernés par ces engins
    .where(simu_engins.const_engins_id.eq(constEngin.id))
/*     .where(

            lf.op.and(simu_engins.const_engins_id.eq(constEngin.id),
                lf.op.or(simu_mouvements.id.eq(currentSimuMouvement.id),
                    lf.op.or(lf.op.and(simu_mouvements.debut.isNotNull(), simu_mouvements.debut.gt(currentSimuMouvement.fin)),
                             lf.op.and(simu_mouvements.fin.isNotNull(), simu_mouvements.fin.lt(currentSimuMouvement.debut)))))
        )*/
     .orderBy(simu_mouvements.debut)
      //.groupBy(simu_echelons_simu_engins.simu_engins_id) // ne fonctionne pas !
      .exec()

      return this.$q.resolve(query)
      .then(resultsArray => {
          console.log('resultsArray', resultsArray); 
          return resultsArray})
      })
    
      .catch(e => {console.log('error ApiSimu::getReusableEngins', e);})

  }


/*
*
   // 1. supprimer l'usage de l'engin dans l'echelon
   // 2. supprimer l'engin réel s'il n'est plus utilisé dans d'autres echelons/mouvements
*/
  deleteEngin(engin) {
    var nb_usages

    return this.deleteSimuEchelonSimuEngin(engin.simu_echelons_simu_engins_id)
    .then( _ => {
      return this.countSimuEnginsUsages(engin.simu_engins_id)
    })
    .then( nb_usages => {
      if(nb_usages == 0)
        return this.deleteSimuEngins(engin.simu_engins_id)
      else
        return nb_usages
      })
  }

/*
* recherche les engins encore référencés dans un échelon
*/
  countSimuEnginsUsages(simu_engins_id) {

    return this.TerrassorDB.getDbConnection()
    .then(db => {

        let {simu_echelons_simu_engins} = this.TerrassorDB.tables
        let query = db
        .select(lf.fn.count(simu_echelons_simu_engins.id))
        .from(simu_echelons_simu_engins)
        .where(simu_echelons_simu_engins.simu_engins_id.eq(simu_engins_id))
        .exec()
        return query
      })
    .then(resultsArray => {
       var N = resultsArray[0]['COUNT(id)']
       console.log('ApiSimu::countSimuEnginsUsages', N)
       return N
    })

  }

/*
*/
  deleteSimuEchelonSimuEngin(id) {
              get_Terrassor_INTERFACE().action({"table":"simu_echelons_simu_engins", "delete":{"id": id}});

    return this.TerrassorDB.deleteRowInTable(id, 'simu_echelons_simu_engins')
  }

  /*
  */
  deleteSimuEngins(id) {
          get_Terrassor_INTERFACE().action({"table":"simu_engins", "delete":{"id": id}});

    return this.TerrassorDB.deleteRowInTable(id, 'simu_engins')
  }


/*
* saveEngin : ajoute une entrée dans simu_engin, puis une entrée dans simu_echelons_esimu_engins
* si engin.simu_engins_id est défini, ce n'est pas un nouvel engin, mais une référence vers un engin déjà présent (dsans un autre echelon / mvt)
*/
  saveEngin(engin, echelon) {

    console.log('ApiSimu::saveEngin', engin)

    if(engin.simu_engins_id == 0) // ce n'est pas une association à un engin existant, donc on crée l'engin
      return this.saveNewEngin(engin, echelon)
    else
      return this.AssociateToEngin(engin, echelon)

}

/**
* Ajout une référence vers un engin existant dans l'échelon
*/
AssociateToEngin(engin, echelon) {
      console.log('ApiSimu::AssociateToEngin', engin)

    var rowSimuEchelonSimuEngin = {"simu_echelons_id" : echelon.id,
                                    "const_phases_id" : engin.const_phases_id,
                                    "const_options_id" : engin.const_options_id,
                                    "const_godets_id" : engin.const_godets_id,
                                    "simu_engins_id" : engin.simu_engins_id,
                                    "const_famillesengins_const_options_const_phases_id" : 0
                                  }
    return this.saveSimuEchelonSimuEngin(rowSimuEchelonSimuEngin, engin.const_engins_id)
    .then(simu_echelons_simu_engins => {
        var retour = get_Terrassor_INTERFACE().action({"table":"simu_echelons_simu_engins", "push":simu_echelons_simu_engins})
        console.log('ApiSimu::AssociateToEngin, INTERFACE.action push', retour)
        return simu_echelons_simu_engins
    })
}


/*
* Nouvel engin dans la table simu_engins, puis dans la table simu_echelon_...
*/
  saveNewEngin(engin, echelon) {
    console.log('ApiSimu::saveNewEngin', engin)

    var rowSimuEngin = {"const_engins_id" : engin.const_engins_id,
                          "reference":engin.reference,
                          "simu_etudes_id": TerrassorConst.CURRENT_ETUDE_ID
                          // id à définir ci-après
                        }
  return this.saveSimuEngin(rowSimuEngin)
  .then(simu_engin => {

    var retour = get_Terrassor_INTERFACE().action({"table":"simu_engins", "push":simu_engin})
    console.log('ApiSimu::saveNewEngin, INTERFACE.action push', retour)

    engin.simu_engins_id = simu_engin.id
    return this.AssociateToEngin(engin, echelon)
  })
}

/*
* avant de sauver, calculer la référence en vérifiant le dernier engin similaire
*/
  saveSimuEngin(rowData) {

    console.log('ApiSimu::saveSimuEngin', rowData)
    /*return this.getSimilarSimuEngins(rowData.const_engins_id)
    .then(similars => {
      var reference = 0
      var last
      if(similars && similars.length){
        last = similars.pop()
        reference = last.reference +1
      }
      else
        reference = 1

    rowData.reference = reference
    getRowInTableImmediateata.reference = 1*/
    return this.TerrassorDB.saveRowInTable (rowData, "simu_engins")
 // })

  }


/*
*/
  recalculateOptionsForSimuEchelonSimuEngin(rowData, const_engins_id) {
    // s'il y a des godets, forcer const_options_id à la valeur de l'option associée
    if(rowData.const_godets_id)
    {
      var optionGodets, optionGodet, optionGodetId
      
      optionGodets = this.TerrassorDB.getJsonTable("const_options")
      optionGodet = optionGodets.filter(o => o.code == 'GODE')
      //console.log('ApiSimu::recalculateOptionsForSimuEchelonSimuEngin, optionGodet', optionGodet)
      optionGodetId = optionGodet[0].id

      rowData.const_options_id = optionGodetId
    }

    // si pas d'option retenue (0), forcer à l'id de sans option 1, ce qui permettra de retrouver un const_famillesengins_const_options_const_phases_id
    if(rowData.const_options_id == 0)
      if(rowData.const_options_id = 1)

   /* console.log('ApiSimu::recalculateOptionsForSimuEchelonSimuEngin, optionGodetId', optionGodetId)
    console.log('ApiSimu::recalculateOptionsForSimuEchelonSimuEngin, const_engins_id', const_engins_id)
*/
    // récupérer le const_famille_id à partir du const_engins_id
    var constEngin,  constFamillesEnginId
    constEngin = this.TerrassorDB.getRowInTableImmediate(const_engins_id, 'const_engins')
    //console.log('ApiSimu::recalculateOptionsForSimuEchelonSimuEngin, constEngin', constEngin)
    constFamillesEnginId = constEngin.const_famillesengins_id
    //console.log('ApiSimu::recalculateOptionsForSimuEchelonSimuEngin, constFamillesEnginId', constFamillesEnginId)

    // retrouver le const_famillesengins_const_options_const_phases_id, à partir des options, de la famille et de la phase
    var const_F_O_Ps, const_F_O_P, const_F_O_PId
    const_F_O_Ps = this.TerrassorDB.getJsonTable("const_famillesengins_const_options_const_phases")
    //console.log('ApiSimu::recalculateOptionsForSimuEchelonSimuEngin, const_F_O_Ps', const_F_O_Ps)
    const_F_O_P = const_F_O_Ps.filter(o => {
                return ((o.const_options_id == rowData.const_options_id)
                          && (o.const_phases_id == rowData.const_phases_id)
                          && (o.const_famillesengins_id == constFamillesEnginId))
                                          })
    console.log('ApiSimu::recalculateOptionsForSimuEchelonSimuEngin, const_F_O_P', const_F_O_P)
    if(const_F_O_P && const_F_O_P.length > 0)
        const_F_O_PId = const_F_O_P[0].id
      else
        const_F_O_PId = 0

    rowData.const_famillesengins_const_options_const_phases_id = const_F_O_PId

    return rowData

  }

/*
*/
  saveSimuEchelonSimuEngin(rowData, const_engins_id) {
    // recalcul des options godets_id et const_famillesengins_const_options_const_phases_id
    rowData = this.recalculateOptionsForSimuEchelonSimuEngin(rowData, const_engins_id)
    console.log('ApiSimu::saveSimuEchelonSimuEngin', rowData)
    return this.TerrassorDB.saveRowInTable(rowData, 'simu_echelons_simu_engins')

  }


  /* Derniers engins (reels) d'un certain modele ajouté (utilisé pour définir la référence d'un nouvel engin)
*/
  getSimilarSimuEngins(const_engins_id) {
    console.log('ApiSimu::getSimilarSimuEngins', const_engins_id)
     return this.TerrassorDB.getDbConnection()
    .then(db => {

        let {simu_engins} = this.TerrassorDB.tables
        let query = db
        .select()
        .from(simu_engins)
        .where(lf.op.and
              (simu_engins.const_engins_id.eq(const_engins_id),
               simu_engins.simu_etudes_id.eq(TerrassorConst.CURRENT_ETUDE_ID))
            )
        .exec()
console.log('ApiSimu::getSimilarSimuEngins before resolve')
        return this.$q.resolve(query)
      })
    .then(resultsArray => {
console.log('ApiSimu::getSimilarSimuEngins after resolve')
      console.log('ApiSimu::getLastSimilarSimuEngin -->', resultsArray)
      //return resultsArray
      return this.$q.resolve(resultsArray)
    })
  }



/*
* Installation déjà créée pour cette étude
* retourne l'enregistrement dans simu_installations ou null (Promise)
*/
 installationExists (etudeId) { 
            
return this.TerrassorDB.loveField.getDbConnection()
  .then(db => {
    let table = this.TerrassorDB.tables["simu_installations"]

    let query = db
        .select()
        .from(table)
        .where(table.simu_etudes_id.eq(etudeId))
        .exec();

      return this.$q.resolve(query)
    })
    // add or update  
    .then(resultsArray => {
      var row
      if(resultsArray.length)
        row = resultsArray[0]
      else
        row = null
      console.log('ApiSimu::installationExists', row)
      return this.$q.resolve(row)
    })
  }

  /*
  * nouvelle installation pour l'étdude
  * retourne l'enregistrement ins&ré
  */

newInstallation(etudeId) {
  var o = {   // pas d'Id renseigné donc c'est un "insert"
            "simu_etudes_id":etudeId,
            "pk":0, // !! point kilométrique et non primary key !!
             "debut":null,
             "fin":null,
             "valide":false,
             "inhibe":false}

        
  return this.TerrassorDB.saveRowInTable(o, "simu_installations")
  .then(result => {
      var retour = get_Terrassor_INTERFACE().action({"table":"simu_installations", "push":result})
      console.log('ApiSimu::newInstallation, INTERFACE.action push', retour)
      return this.$q.resolve(result)
  })        

}


/*
*
*/
saveNewEquipments(eqpts, simu_installations_id) {
  console.log('ApiSimu::saveNewEquipment', eqpts)
  var q = 0
    // lire les eqpts déjà enregistrés
    return this.getSimilarEquipements(eqpts.const_installations_id, simu_installations_id)
    .then(similarEqpts => {

      if(similarEqpts.length) {
          // récupère la quantité si eqpts existants
          var sE = similarEqpts[0]
          q = sE.quantite
          // delete l'enregistremenbt précédent
          get_Terrassor_INTERFACE().action({"table":"simu_installations_const_installations", "delete":{"id": sE.id}});      
          return this.TerrassorDB.deleteRowInTable(sE.id, "simu_installations_const_installations")
        }
      else
          q = 0        
    })
    .then(_ => {
      // cumule les quantités et sauve en DB  
      var rowData = eqpts
      rowData.quantite += q
      return this.TerrassorDB.saveRowInTable (rowData, "simu_installations_const_installations")      
    })
    .then(result => {
      // push dans l'interface  
      var retour = get_Terrassor_INTERFACE().action({"table":"simu_installations_const_installations", "push":result})
      console.log('ApiSimu::saveNewEquipment, INTERFACE.action push', retour)
      return this.$q.resolve(result)
  })
}


/*
* oçbtention d'equipements d'installation déjà enregistrés
*/
getSimilarEquipements(const_installations_id, simu_installations_id) {
     return this.TerrassorDB.getDbConnection()
    .then(db => {

        let {simu_installations_const_installations} = this.TerrassorDB.tables
        let query = db
        .select()
        .from(simu_installations_const_installations)
        .where(lf.op.and
              (simu_installations_const_installations.const_installations_id.eq(const_installations_id),
               simu_installations_const_installations.simu_installations_id.eq(simu_installations_id))
            )
        .exec()
        return this.$q.resolve(query)
      })
    .then(resultsArray => {
      console.log('ApiSimu::getSimilarEquipements -->', resultsArray)
      //return resultsArray
      return this.$q.resolve(resultsArray)
    })

}

/*
* Tous les equipementq presta d'un installation
*/
getAllEquipements(installationId) {

    return this.TerrassorDB.getDbConnection()
    .then(db => {
    let { simu_installations_const_installations } = this.TerrassorDB.tables
    let { const_installations } = this.TerrassorDB.tables
    let query;

    query = db
    .select()
    .from(simu_installations_const_installations)
    .innerJoin(const_installations, 
      simu_installations_const_installations.const_installations_id.eq(const_installations.id))
    //.where(simu_installations_const_installations.simu_installations_id.eq(installationId))              
    .exec()

    return this.$q.resolve(query)
    })
    .catch(e => {console.log('error ApiSimu::getAllEquipements', e);})

  }



  /*
  *
  */
  getMouvementByCode(codeMvt) {

    return this.TerrassorDB.getDbConnection()
    .then(db => {
            // On récupère la référence vers la table
    let { simu_mouvements } = this.TerrassorDB.tables
    let { exo_mouvements } = this.TerrassorDB.tables
    let query;

    query = db
    .select()
    .from(simu_mouvements)
    .innerJoin(exo_mouvements,
        exo_mouvements.id.eq(simu_mouvements.exo_mouvements_id))
    .where(exo_mouvements.code.eq(codeMvt))
    .exec()

    
    return this.$q.resolve(query).then(resultsArray => resultsArray.pop());
    })

  }

/*
* Retourne un mouvement de l'étude/simu, null s'il n'y en a pas encore
*/
  getMouvementByExoMouvementId(exo_mouvements_id) {
    //console.log('ApiSimu::getMouvementByExoMouvementId ', exo_mouvements_id, TerrassorConst.CURRENT_ETUDE_ID)

    return this.TerrassorDB.getDbConnection()
    .then(db => {
            // On récupère la référence vers la table
    let { simu_mouvements } = this.TerrassorDB.tables
    let query;

    query = db
    .select()
    .from(simu_mouvements)
    .where(lf.op.and
              (simu_mouvements.exo_mouvements_id.eq(exo_mouvements_id),
                simu_mouvements.simu_etudes_id.eq(TerrassorConst.CURRENT_ETUDE_ID)))
    .exec()

    return this.$q.resolve(query).then(resultsArray => resultsArray.pop());
    })
    .catch(e => {console.log('error ApiSimu::getMouvementByExoMouvementId', e);})

  }


  getAllValidSimuMouvements(etudeId) {
     return this.TerrassorDB.getDbConnection()
    .then(db => {
    let { simu_mouvements } = this.TerrassorDB.tables
    let { exo_mouvements } = this.TerrassorDB.tables
    let query;

    query = db
    .select()
    .from(simu_mouvements)
    .innerJoin(exo_mouvements, 
      simu_mouvements.exo_mouvements_id.eq(exo_mouvements.id))
    .where(lf.op.and(
              simu_mouvements.valide.eq(1),
              simu_mouvements.simu_etudes_id.eq(etudeId)))
    .exec()
    return this.$q.resolve(query)
    })
    .catch(e => {console.log('error ApiSimu::getAllValidSimuMouvements', e);})

  }



  
/*
*Nouvelle entrée dans la table simu_mouvements
*/
  createMouvement(exo_mouvements_id) {

    let { simu_mouvements } = this.TerrassorDB.tables

    var row = simu_mouvements.createRow({
          'simu_etudes_id':TerrassorConst.CURRENT_ETUDE_ID,
          'exo_mouvements_id': exo_mouvements_id})

    console.log('ApiSimu::createMouvement ajout de ', row)

    // On execute la requete d'insertion
    // https://github.com/google/lovefield/blob/master/docs/spec/04_query.md
    return this.TerrassorDB.getDbConnection()
    .then(db => {
    let query = db
        .insertOrReplace()
        .into(simu_mouvements)
        .values([row]) // Toujours dans un tableau même s'il n'y en a qu'une.
        .exec()

    return this.$q.resolve(query)
    .then(resultsArray => {
        var insertedRow = resultsArray.pop()
        return insertedRow
     })

    })
    .catch(e => {console.log('error ApiSimu::createMouvement', e);})
  }

/*
*
*/
  saveMouvement(simuMouvement) {
    return this.TerrassorDB.getDbConnection()
    .then(db => {
      // On récupère la référence vers la table
      let { simu_mouvements } = this.TerrassorDB.tables

      // On crée une nouvelle entrée sur la table
      let newRow = simu_mouvements.createRow(simuMouvement)

      // On execute la requete d'insertion
      // https://github.com/google/lovefield/blob/master/docs/spec/04_query.md
      let query = db
        .insertOrReplace()
        .into(simu_mouvements)
        .values([newRow]) // Toujours dans un tableau même s'il n'y en a qu'une.
        .exec()

      // On retourne la promesse de la requete
      return this.$q.resolve(query)
        })
      .then(resultsArray => {
        var m = resultsArray.pop()
        this.pushMouvementToInterface(m)
        return m  
    })
  }

  /*
* Reformatter les dates dans une syntaxe acceptable par l'INTERFACE ex: 2017-12-04T00:00:00+00:00 
*/
    pushMouvementToInterface(simuMouvement) {
       var debut, fin

        debut = simuMouvement.debut  
        fin = simuMouvement.fin 
          //dates incohérentes / plantage dans le push
        if(debut.getTime() >= fin.getTime())
          return

        debut = dateFns.addHours(debut, 12) // décaler à 12:00 pour éviter le changement de jour lors des modifs de timezone été / hiver
        fin = dateFns.addHours(fin, 12)       
        debut = JSON.stringify(debut)        
        debut = debut.substring(1, 11) + 'T00:00:00+00:00'
        fin = JSON.stringify(fin)
        fin = fin.substring(1, 11) + 'T00:00:00+00:00'

        // faire une copie de l'objet pour ne pas modifier sa référence
        var copyMvt = Object.assign({}, simuMouvement)
        copyMvt.debut=debut
        copyMvt.fin=fin

        console.log('ApiSimu::pushMouvementToInterface  ', copyMvt )
        var retour = get_Terrassor_INTERFACE().action({"table":"simu_mouvements", "push":copyMvt})
    }


    /*
    */
    saveAnalyse(analyse) {
      // dupliquer l'objet avant de serialiser
      /*var analyseTosave = JSON.parse(JSON.stringify(analyse))
      this.serializeAnalyseFields(analyseTosave)

     return this.TerrassorDB.saveRowInTable (analyseTosave, "simu_analyses")*/
     return this.TerrassorDB.saveRowInTable (analyse, "simu_analyses")

    }

/*
* raz de l'analyse de l'étude en cours (utilisé lors de la correction)
*/
    deleteAnalyse(id) {
      return this.TerrassorDB.getDbConnection()
      .then(db => {

      let table = this.TerrassorDB.tables['simu_analyses']

      let query = db
      .delete()
      .from(table)
      // .where(table.simu_etudes_id.eq(id)) // BC 2018/02 pb de compatibilité verticale - on peut avoir, je ne sais pas pourquoi, des analyses avec une id_etude à 0 ... et comme on ne gère qu'une étude à la fois ...
      .exec()

      return this.$q.resolve(query)
    })
    }

    /*
    */
    serializeAnalyseFields(analyse) {

      this.analyseFieldsToSerialize.forEach(f => {
        analyse[f] = JSON.stringify(analyse[f])
      })
    }

/*
* Pour l'init de l'interface au lancement
*/
    deSerializeSimuAnalyses(table)
    {
      // pas de forEach pour debug
      for(var i=0; i<table.length; i++) {
          var a = table[i]
          for (var j=0; j<this.analyseFieldsToSerialize.length; j++) {
            var f = this.analyseFieldsToSerialize[j]
            if(typeof(a[f]) == 'string' && a[f] != '')
              a[f] = JSON.parse(a[f])
          }
        }
      return table
    }

  /*
  * @todo à passer dans TerrassorDB
  */
  exportAllTerrassor() {
      return this.TerrassorDB.getDbConnection()
      .then(db => {
         return db.export()
      })
      .then(data => {
        console.log('exportAllTerrassor : DB exported to json successfully', data)
          this.TerrassorDB.setJsonTables(data); // BC 2019/04 - on initialise le allJsonData car les exo n'y sont pas forcément (création d'épure)
        return data
      })
  }

    /*
    * BC 2019/04 - on initialise le allJsonData car les exo n'y sont pas forcément (création d'épure)
    */
reinitAllTerrassor(data) {
      this.TerrassorDB.setJsonTables(data);
}


/*
  *
  */
  deleteMouvementEleve(idMouvement, delDB) {
      if (delDB) {
          return this.TerrassorDB.deleteRowInTable(idMouvement, 'simuexo_mouvements')
            .then(_ => {
              return(this.deleteMouvementsCubaturesEleve(idMouvement));
          })
      }
    else {
          return(this.deleteMouvementsCubaturesEleve(idMouvement));
    }
  }

/*
*Nouvelle entrée dans la table simu_mouvements
*/
  createSimuExoMouvementEleve(exo_chantiers_id ) {

    let { simuexo_mouvements } = this.TerrassorDB.tables

    var row = simuexo_mouvements.createRow({
          'exo_chantiers_id': exo_chantiers_id,
          'nom': '' })

    console.log('ApiSimu::createMouvementEleve ajout de ', row)

    // On execute la requete d'insertion
    // https://github.com/google/lovefield/blob/master/docs/spec/04_query.md
    return this.TerrassorDB.getDbConnection()
    .then(db => {
    let query = db
        .insertOrReplace()
        .into(simuexo_mouvements)
        .values([row]) // Toujours dans un tableau même s'il n'y en a qu'une.
        .exec()

    return this.$q.resolve(query)
    .then(resultsArray => {
        var insertedRow = resultsArray.pop()
        return(insertedRow)
     })

    })
    .catch(e => {console.log('error ApiSimu::simuexo_mouvements', e);})
  }


/*
*
*/


/*
*
*/
    /*
  getSimuExoMouvementCubatureEleve(mouvementEleveId) {
    return this.TerrassorDB.getDbConnection()
    .then(db => {
      // On récupère la référence vers la table
      let { simuexo_mouvements_simuexo_cubatures } = this.TerrassorDB.tables

      let query;
        query = db
          .select()
          .from(simuexo_mouvements_simuexo_cubatures)
          .where(simuexo_mouvements_simuexo_cubatures.simuexo_mouvements_id.eq(mouvementEleveId))
          .exec()
      // On retourne la promesse de la requete
      return this.$q.resolve(query)
    })
  }
*/

      /*
  *
  */
    /*
  deleteSimuExoMouvementsCubaturesEleve(idMouvement) {
      var lApi = this;
    return this.getMouvementCubatureEleve(idMouvement)
    .then(resultArray => {
        var allPromises = []
        resultArray.forEach(elt => {
            var promise = lApi.TerrassorDB.deleteRowInTable(elt.id, "simuexo_mouvements_simuexo_cubatures")
            allPromises.push(promise)
        })
        return Promise.all(allPromises)
    })
  }
*/
/*
*
*/
/*saveSimuExoMouvementCubatureEleve(exomouvements_exo_cubatures) {
    return this.TerrassorDB.getDbConnection()
    .then(db => {
      // On récupère la référence vers la table
      let { simuexo_mouvements_simuexo_cubatures } = this.TerrassorDB.tables

      // On crée une nouvelle entrée sur la table
      let newRow = simuexo_mouvements_simuexo_cubatures.createRow(exomouvements_exo_cubatures)

      // On execute la requete d'insertion
      // https://github.com/google/lovefield/blob/master/docs/spec/04_query.md
      let query = db
        .insertOrReplace()
        .into(simuexo_mouvements_simuexo_cubatures)
        .values([newRow]) // Toujours dans un tableau même s'il n'y en a qu'une.
        .exec()

      // On retourne la promesse de la requete
      return this.$q.resolve(query)
        })
      .then(resultsArray => {
        var mc = resultsArray.pop()
//        this.pushMouvementToInterface(m)
        return mc
    })

}
*/

}



// WEBPACK FOOTER //
// ./src/client/common/api/ApiSimu.js